// extracted by mini-css-extract-plugin
export default {"Sidebar":"AdminSidebar_Sidebar__VORij"};